import MAPINIT from '../plugins/mapinit'

export default () => {
  
  $(() => {
    const d_map = document.querySelectorAll('[data-plugin="googlemap"]')
    if(d_map.length) MAPINIT(d_map)
  })

}